module.exports = new __parcel__URL__("LoomIcon.065e0b4f.svg").toString();